import { render, staticRenderFns } from "./PxCamposProdutoUseallSetup.vue?vue&type=template&id=0c0a931c&"
import script from "./PxCamposProdutoUseallSetup.vue?vue&type=script&lang=js&"
export * from "./PxCamposProdutoUseallSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports